<template>
    <div class="modal-blackjack-rules">
        <div class="rules-header">
            <h2 class="rules-title">Blackjack Game Rules</h2>
            <p class="rules-subtitle">Comprehensive payout information and game mechanics</p>
        </div>
        
        <div class="rules-content">
            <!-- 21 + 3 Payouts Section -->
            <div class="rules-section">
                <div class="section-header">
                    <div class="section-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <h3 class="section-title">21 + 3 Payouts</h3>
                </div>
                <div class="section-content">
                    <div class="payout-card">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">5x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Flush</h4>
                            <p class="payout-description">Three cards in the same suit</p>
                        </div>
                    </div>
                    <div class="payout-card">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">10x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Straight</h4>
                            <p class="payout-description">Three cards of consecutive values, such as 2/3/4. Aces can be high or low.</p>
                        </div>
                    </div>
                    <div class="payout-card">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">30x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Three of a Kind</h4>
                            <p class="payout-description">Three cards of the same value or face card</p>
                        </div>
                    </div>
                    <div class="payout-card">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">40x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Straight Flush</h4>
                            <p class="payout-description">Three cards of consecutive values that are all in the same suit</p>
                        </div>
                    </div>
                    <div class="payout-card payout-card-premium">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">100x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Suited Three of a Kind</h4>
                            <p class="payout-description">Three cards of the same value or face card and the same suit</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Blackjack Section -->
            <div class="rules-section">
                <div class="section-header">
                    <div class="section-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 16V8C20.9996 7.64928 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64928 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M3.27 6.96L12 12.01L20.73 6.96" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <h3 class="section-title">Blackjack</h3>
                </div>
                <div class="section-content">
                    <div class="payout-card payout-card-special">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">1.5x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Blackjack</h4>
                            <p class="payout-description">Achieve a total of 21 with your first two cards</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Perfect Pairs Section -->
            <div class="rules-section">
                <div class="section-header">
                    <div class="section-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                            <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                            <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                            <rect x="14" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="2"/>
                        </svg>
                    </div>
                    <h3 class="section-title">Perfect Pairs: Side Bet</h3>
                </div>
                <div class="section-content">
                    <div class="payout-card">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">25x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Perfect Pair</h4>
                            <p class="payout-description">Two cards of the same rank and suit</p>
                        </div>
                    </div>
                    <div class="payout-card">
                        <div class="payout-multiplier">
                            <span class="multiplier-value">10x</span>
                        </div>
                        <div class="payout-details">
                            <h4 class="payout-name">Colored Pair</h4>
                            <p class="payout-description">Two cards of the same rank and color</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ModalBlackjackRules'
    }
</script>

<style scoped>
    .modal-blackjack-rules {
        width: 900px;
        max-width: 95vw;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 40px 50px 50px 50px;
        border-radius: 20px;
        background: linear-gradient(135deg, rgba(26, 26, 46, 0.98) 0%, rgba(19, 19, 35, 0.98) 100%);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(212, 165, 116, 0.2);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    }

    .rules-header {
        text-align: center;
        margin-bottom: 40px;
        padding-bottom: 30px;
        border-bottom: 1px solid rgba(212, 165, 116, 0.2);
    }

    .rules-title {
        font-size: 32px;
        font-weight: 700;
        color: #ffffff;
        margin: 0 0 10px 0;
        letter-spacing: 0.5px;
    }

    .rules-subtitle {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        margin: 0;
    }

    .rules-content {
        max-height: 550px;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 10px;
    }

    .rules-content::-webkit-scrollbar {
        width: 6px;
    }

    .rules-content::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
    }

    .rules-content::-webkit-scrollbar-thumb {
        background: var(--accent-yellow);
        border-radius: 10px;
    }

    .rules-content::-webkit-scrollbar-thumb:hover {
        background: var(--accent-yellow-main);
    }

    .rules-section {
        margin-bottom: 35px;
    }

    .rules-section:last-child {
        margin-bottom: 0;
    }

    .section-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 2px solid rgba(212, 165, 116, 0.3);
    }

    .section-icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(212, 165, 116, 0.15);
        border-radius: 10px;
        color: var(--accent-yellow);
        flex-shrink: 0;
    }

    .section-icon svg {
        width: 20px;
        height: 20px;
    }

    .section-title {
        font-size: 22px;
        font-weight: 700;
        color: #ffffff;
        margin: 0;
        letter-spacing: 0.3px;
    }

    .section-content {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .payout-card {
        display: flex;
        align-items: center;
        gap: 20px;
        padding: 20px 24px;
        background: rgba(255, 255, 255, 0.03);
        border: 1px solid rgba(212, 165, 116, 0.15);
        border-radius: 12px;
        transition: all 0.3s ease;
    }

    .payout-card:hover {
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(212, 165, 116, 0.3);
        transform: translateX(4px);
    }

    .payout-card-premium {
        background: linear-gradient(135deg, rgba(212, 165, 116, 0.1) 0%, rgba(212, 165, 116, 0.05) 100%);
        border-color: rgba(212, 165, 116, 0.4);
    }

    .payout-card-special {
        background: linear-gradient(135deg, rgba(85, 158, 228, 0.1) 0%, rgba(85, 158, 228, 0.05) 100%);
        border-color: rgba(85, 158, 228, 0.3);
    }

    .payout-multiplier {
        min-width: 80px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, var(--accent-yellow) 0%, var(--accent-yellow-main) 100%);
        border-radius: 12px;
        box-shadow: 0 4px 15px rgba(212, 165, 116, 0.3);
        flex-shrink: 0;
    }

    .payout-card-premium .payout-multiplier {
        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
        box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
    }

    .payout-card-special .payout-multiplier {
        background: linear-gradient(135deg, #559ee4 0%, #3d7fc7 100%);
        box-shadow: 0 4px 15px rgba(85, 158, 228, 0.3);
    }

    .multiplier-value {
        font-size: 28px;
        font-weight: 900;
        color: #1a1a2e;
        letter-spacing: -0.5px;
    }

    .payout-details {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .payout-name {
        font-size: 18px;
        font-weight: 700;
        color: #ffffff;
        margin: 0;
        letter-spacing: 0.3px;
    }

    .payout-description {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.7);
        margin: 0;
        line-height: 1.5;
    }

    @media only screen and (max-width: 990px) {
        .modal-blackjack-rules {
            width: calc(100vw - 40px);
            padding: 35px 30px 40px 30px;
        }

        .rules-title {
            font-size: 28px;
        }

        .rules-content {
            max-height: 500px;
        }
    }

    @media only screen and (max-width: 768px) {
        .modal-blackjack-rules {
            width: calc(100vw - 30px);
            padding: 30px 20px 35px 20px;
        }

        .rules-header {
            margin-bottom: 30px;
            padding-bottom: 20px;
        }

        .rules-title {
            font-size: 24px;
        }

        .rules-subtitle {
            font-size: 13px;
        }

        .section-header {
            margin-bottom: 18px;
            padding-bottom: 12px;
        }

        .section-icon {
            width: 36px;
            height: 36px;
        }

        .section-icon svg {
            width: 18px;
            height: 18px;
        }

        .section-title {
            font-size: 20px;
        }

        .payout-card {
            padding: 16px 20px;
            gap: 16px;
        }

        .payout-multiplier {
            min-width: 70px;
            height: 70px;
        }

        .multiplier-value {
            font-size: 24px;
        }

        .payout-name {
            font-size: 16px;
        }

        .payout-description {
            font-size: 13px;
        }
    }

    @media only screen and (max-width: 550px) {
        .modal-blackjack-rules {
            width: calc(100vw - 20px);
            padding: 25px 15px 30px 15px;
        }

        .rules-header {
            margin-bottom: 25px;
            padding-bottom: 15px;
        }

        .rules-title {
            font-size: 22px;
        }

        .rules-subtitle {
            font-size: 12px;
        }

        .section-header {
            gap: 10px;
            margin-bottom: 15px;
        }

        .section-icon {
            width: 32px;
            height: 32px;
        }

        .section-icon svg {
            width: 16px;
            height: 16px;
        }

        .section-title {
            font-size: 18px;
        }

        .section-content {
            gap: 10px;
        }

        .payout-card {
            flex-direction: column;
            align-items: flex-start;
            padding: 16px;
            gap: 12px;
        }

        .payout-multiplier {
            min-width: 60px;
            height: 60px;
            align-self: flex-start;
        }

        .multiplier-value {
            font-size: 20px;
        }

        .payout-name {
            font-size: 15px;
        }

        .payout-description {
            font-size: 12px;
        }
    }
</style>
